import React from 'react';
import { Link } from 'react-router-dom';
let config = require('../../cc-config.json');
import Categories from '../building/categories';
import './welcome.css';
const Welcome = () => (React.createElement("div", { className: "section-body welcome" },
    React.createElement(Categories, { mode: "view" }),
    React.createElement("h1", { className: "h3" },
        "Welcome to Colouring ",
        config.cityName,
        "!"),
    React.createElement("p", null,
        "Colouring ",
        config.cityName,
        " is a free knowledge exchange platform designed to provide open data on Historic Cities buildings, to help make them more sustainable."),
    React.createElement("p", null,
        "Colouring ",
        config.cityName,
        " is part of the Colouring Cities Research programme based at the Alan Turing Institute. The programme ",
        React.createElement("strong", null, "collaborates"),
        " with local, regional, national and international partners to develop open platform code also of relevance to other cities."),
    React.createElement("p", null,
        "New datasets and features are added regularly, and we greatly appreciate any information you contribute. All submissions are carefully reviewed by the Colouring ",
        config.cityName,
        " team before being shared on the platform."),
    React.createElement("p", null, "All our data and code are free to download, use and share under our open licence terms."),
    React.createElement(Link, { to: "/view/categories", className: "btn btn-outline-dark btn-lg btn-block" }, "Start Colouring Here!"),
    React.createElement("div", { className: "image-row" },
        React.createElement("img", { className: "cl-logo", src: "/images/logo-cc.jpg?v=2", alt: "Colouring Cities Research Programme" }),
        React.createElement("img", { className: "turing-logo", src: "/images/logo-turing.jpg?v=2", alt: "Alan Turing Institute" })),
    React.createElement("div", { className: "image-row" },
        React.createElement("img", { className: "baca-logo", src: "/images/logo-baca.png?v=1", alt: "Bahrain Authority for Culture & Antiquities" }),
        React.createElement("img", { className: "uob-logo", src: "/images/logo-uob.png?v=1", alt: "University of Bahrain" }))));
export default Welcome;
